<template>
    <div class="gift-img">
        <CoverPanel
            class="image-upload"
            :noCoverIcon="editConfig.noCoverIcon"
            :imageUrl="cardImage"
            :operateIcons="editConfig.operateIcons"
            :viewIcon="editConfig.viewIcon"
            ishorizontal="true"
            @uploadCover="uploadCover"
            @operatorSelect="operatorSelect"
            @imageClick="showBigPicture"
        />
        <div class="icon-wrapper"></div>
    </div>
</template>

<script>
import ImageClipModal from "@/views/zhiji/components/imageUpload/ImageClipModal";
import ImageViewModal from "@/views/zhiji/components/questionEdit/modals/ImageViewModal";
import i18n from "@/i18n";

const iconConfig = () => ({
    noCoverIcon: {
        position: "-145px -50px",
        label: i18n.t("zhiji.answer.packageWidge.uploadIcon")
    },
    operateIcons: [
        {
            type: "update",
            position: "-38px -77px",
            name: i18n.t("zhiji.answer.packageWidge.updateIcon")
        }
    ],
    viewIcon: {
        position: "-172px -74px",
        isShowIcon: true
    }
});

import CoverPanel from "../CoverPanel";
export default {
    name: "PackageIcon",
    props: ["iconImage"],
    components: {
        CoverPanel
    },
    data() {
        return {
            cardImage: this.iconImage || ""
        };
    },
    model: {
        prop: "iconImage",
        event: "uploadImage"
    },
    computed: {
        editConfig() {
            return iconConfig();
        }
    },
    methods: {
        uploadCover() {
            this.uploadImage(imageUrl => {
                this.cardImage = imageUrl;
                this.$emit("uploadImage", this.cardImage);
            });
        },
        uploadImage(cb) {
            this.$store.commit("zhiji/showModal", {
                type: ImageClipModal,
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: false
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        },
        operatorSelect(type) {
            if (type == "update") {
                this.uploadImage(imageUrl => {
                    this.cardImage = imageUrl;
                    this.$emit("uploadImage", this.cardImage);
                });
            }
        },
        showBigPicture() {
            this.cardImage &&
                this.$store.commit("zhiji/showModal", {
                    type: ImageViewModal,
                    data: {
                        url: this.cardImage
                    }
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.image-upload {
    width: 142px;
    height: 107px;
    margin-right: 8px;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    cursor: pointer;

    .cover-image-panel {
        border-radius: 4px;
        overflow: hidden;
        & > img {
            max-width: none;
        }
    }
}
</style>
